export default "__VITE_ASSET__iAS_UXVp__"